var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var HeartIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 60,
    glyphHeight: 57,
    glyphOffsetY: 2
  }), React.createElement("path", {
    d: "M56.1241 9.53293C52.005 3.25636 44.7477 -0.0780782 37.4905 0.902637C34.7445 1.29492 32.1946 2.27564 29.8409 3.64864C27.4872 2.27564 24.9373 1.29492 22.1913 0.902637C14.934 -0.0780782 7.67671 3.25636 3.55771 9.53293C-1.14972 16.7902 -0.757438 26.2051 4.93071 35.4238C11.2073 45.8194 21.0144 51.7037 29.8409 56.9996C38.4712 51.7037 48.2783 45.6233 54.751 35.4238C60.4392 26.2051 61.0276 16.7902 56.1241 9.53293ZM48.2783 31.1087C43.767 38.366 36.902 43.4657 30.037 47.5847C23.172 43.2695 16.307 38.366 11.7957 31.1087C7.87286 24.636 7.28443 18.3594 10.4227 13.6519C12.7764 9.92522 17.0916 7.96379 21.4067 8.55222C24.7412 8.94451 27.6833 10.9059 30.037 14.0442C32.3907 10.9059 35.3329 8.94451 38.6673 8.55222C42.9825 7.96379 47.1015 9.92522 49.6513 13.6519C52.5935 18.3594 52.2012 24.8321 48.2783 31.1087Z"
  }));
};
export var HeartIconGlyph = function (props) {
  return React.createElement(HeartIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};